import { render, staticRenderFns } from "./tmp-court-info.vue?vue&type=template&id=240c1f3f&"
import script from "./tmp-court-info.vue?vue&type=script&lang=js&"
export * from "./tmp-court-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports